import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcActivities = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M21.449 13H17l-2.7 3.6a1 1 0 0 1-1.737-.249l-2.359-6.29-1.904 2.54a1 1 0 0 1-.8.4H2.553c.5 4.776 4.539 8.5 9.448 8.5 4.909 0 8.948-3.724 9.448-8.5Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M21.449 11H16.5a1 1 0 0 0-.8.4l-1.905 2.54-2.359-6.291A1 1 0 0 0 9.701 7.4L7 11H2.553c.5-4.777 4.539-8.5 9.448-8.5 4.909 0 8.948 3.723 9.448 8.5Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcActivities");

export { IcActivities };
//# sourceMappingURL=ic-activities.js.map
